export default import.meta.ROLLUP_FILE_URL_C6x6bD7q;